export const GetWidth = typeof window !== "undefined" && window.innerWidth;
export const GetHeight = typeof window !== "undefined" && window.innerHeight;
